//imports
import {
    UNSUBSCRIBED_CONTACT_CREATE_REQUEST,
    UNSUBSCRIBED_CONTACT_CREATE_RESULT,
    UNSUBSCRIBED_CONTACT_CREATE_OPEN_MODAL,
    UNSUBSCRIBED_CONTACT_CREATE_CLOSE_MODAL,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    loading: false,
    createdUnsubscribedContact: null,
    openModal: false,
    currentId: null,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case UNSUBSCRIBED_CONTACT_CREATE_OPEN_MODAL:
            return { ...state, openModal: true, currentId: action.payload?.id || null }

        case UNSUBSCRIBED_CONTACT_CREATE_CLOSE_MODAL:
            return { ...state, openModal: false }


        case UNSUBSCRIBED_CONTACT_CREATE_REQUEST:
            return { ...state, loading: true }

        case UNSUBSCRIBED_CONTACT_CREATE_RESULT:
            return { ...state, loading: false, createdUnsubscribedContact: action?.payload }

        case CLEAR_REDUX:
            return ["", "UNSUBSCRIBED_CONTACT_CREATE"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
